import PrimaryCard from 'components/Statistics/PrimaryCard';
import StatisticsSharedCards from 'components/Statistics/StatisticsSharedCards';
import React from 'react';
import { getProjectDashboardData } from 'services/projects';
import { BygrModule, BygrProjectDetails } from 'types';
import { useAsyncState, useAsyncStateWithIsLoading } from 'utils/hooks';
import theme from './ProjectDashboard.module.scss';
import { getProjectLicenseStatus } from 'services/licenses';
import { startCase } from 'lodash';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';

interface ProjectDashboardProps {
    project: BygrProjectDetails;
}

const ProjectDashboard: React.FC<ProjectDashboardProps> = ({ project }) => {
    const [data] = useAsyncStateWithIsLoading(() => getProjectDashboardData(project.id), [project.id], null);
    const [licenseStatus] = useAsyncState(() => getProjectLicenseStatus(project!.id), [project.id], null);

    const showModules = (v: BygrModule) => {
        const out: string[] = [];

        Object.keys(BygrModule).forEach((bm) => {
            if (BygrModule[bm] & v) {
                out.push(bm);
            }
        });
        return out.join(', ');
    };

    return (
        <div className={theme.dashboardContainer}>
            <PrimaryCard loading={!data}>
                {() => (
                    <>
                        <PrimaryCard.Row label="Buyers">{data!.numberOfBuyers}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Units">
                            {data!.numberOfSoldUnits}/{data!.numberOfUnits} sold
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Modules">{showModules(project.sellerModules)}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Seller profile">
                            <CustomLink to={`/profiles/${project.sellerProfile.id}`}>
                                {project.sellerProfile.name}
                            </CustomLink>
                        </PrimaryCard.Row>
                    </>
                )}
            </PrimaryCard>

            <StatisticsSharedCards projectIds={[project.id]} />

            <PrimaryCard loading={!licenseStatus} title="Licenses">
                {() => (
                    <>
                        {licenseStatus!.map((item) => (
                            <PrimaryCard.Row key={item.module} label={startCase(item.module)}>
                                <span className={item.exceededLimit ? theme.licenseExceeded : undefined}>
                                    {item.actualUnits} / {item.isUnlimited ? 'Unlimited' : item.allowedUnits} units
                                </span>
                            </PrimaryCard.Row>
                        ))}
                    </>
                )}
            </PrimaryCard>
        </div>
    );
};

export default ProjectDashboard;
